import axios, { AxiosPromise } from 'axios'

import {
  SepaMandateRequest,
  SepaMandateResponse,
} from '@/lib/definitions/api.types'
import { addBaseUrl, getAxiosRequestConfigWithHeaders } from '@/lib/misc/Utils'

export class BillingService {
  updateSepaMandate(
    data: SepaMandateRequest
  ): AxiosPromise<SepaMandateResponse> {
    return axios.put(
      addBaseUrl('payment/sepa'),
      data,
      getAxiosRequestConfigWithHeaders()
    )
  }

  getSepaMandateStatus(): AxiosPromise<SepaMandateResponse | null> {
    return axios.get(
      addBaseUrl('payment/sepa'),
      getAxiosRequestConfigWithHeaders()
    )
  }
}
